import { Box } from '@chakra-ui/react';

interface ChatPanelBodyPinnedProps {
  mini?: boolean;
  children: React.ReactNode;
}

function ChatPanelBodyPinned({ mini = false, children }: ChatPanelBodyPinnedProps) {
  const cssProps = mini
    ? {
        mt: '2.5',
        mx: '2.5',
        borderRadius: 'md',
        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.10)',
        backdropFilter: 'blur(12.039070129394531px)',
      }
    : {};
  return (
    <Box
      className="ChatPanelBodyPinned slideFromTopFull"
      css={{ animationDelay: '0.5s', animationFillMode: 'forwards', opacity: 0 }}
      bg="white"
      {...cssProps}
    >
      {children}
    </Box>
  );
}

const MemoizedChatPanelBodyPinned = memo(ChatPanelBodyPinned);

export { MemoizedChatPanelBodyPinned as ChatPanelBodyPinned };
